import { useHtmlId } from '@ipfabric/frontend-shared-assets/utils/react/HtmlId';
import type { ReactNode } from 'react';
import { FormField } from '../FormField/FormField';
import type { FormFieldBaseProps } from '../FormField/FormField.types';
import { Select } from '../Select/Select';
import type { SelectMandatoryProps, SelectProps } from '../Select/Select.types';

export type SelectFieldProps<TValue extends string> = SelectProps<TValue> &
  FormFieldBaseProps;

export type SelectMandatoryFieldProps<TValue extends string> =
  SelectMandatoryProps<TValue> & FormFieldBaseProps;

/**
 * Select form field allowing null value
 */
const Optional = <TValue extends string>({
  className,
  error,
  name,
  ...props
}: SelectFieldProps<TValue>) => {
  const selectInputId = useHtmlId('selectInput');
  return (
    <FormField
      className={className}
      htmlFor={selectInputId}
      error={error}
      {...props}
    >
      <Select.Optional
        hasError={props.hasError || error !== undefined}
        name={name}
        inputId={selectInputId}
        {...props}
      />
    </FormField>
  );
};

/**
 * Select form field not allowing null value
 */
const Mandatory: <TValue extends string>(
  props: SelectMandatoryFieldProps<TValue>,
) => ReactNode = Optional as any;

export const SelectField = { Mandatory, Optional };
